import React, { useState, useEffect } from 'react';
import './ChartCheckbox.css';

const ChartCheckbox = ({ initialChecked = false, disabled = false, color = '#0B0932', size = '30px', fillSize = '80%', label = "Title", onChange, reset }) => {
    const [isChecked, setIsChecked] = useState(initialChecked);

    useEffect(() => {
        setIsChecked(initialChecked);
    }, [initialChecked]);

    useEffect(() => {
        if (reset) {
            setIsChecked(initialChecked);
        }
    }, [reset, initialChecked]);

    const toggleCheckbox = () => {
        if (!disabled) {
            const newCheckedState = !isChecked;
            setIsChecked(newCheckedState);

            if (onChange) {
                onChange(newCheckedState);
            }
        }
    };

    return (
        <div className='chart-checkbox-wrap'>
            <div onClick={toggleCheckbox}
                className="custom-checkbox"
                style={{
                    width: size,
                    height: size,
                    border: `1px solid grey`,
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: "#fff"
                }}
            >
                <div
                    className={`fill ${isChecked ? 'fill-checked' : ''}`}
                    style={{
                        backgroundColor: color,
                        transform: isChecked ? 'scale(1)' : 'scale(0)',
                        transition: 'transform 0.1s ease',
                        width: fillSize,
                        height: fillSize,
                    }}
                >
                </div>
            </div>
            {label !== "" && (
                <div className='chart-checkbox-label'>
                    <span>{label}</span>
                </div>
            )}
        </div>
    );
};

export default ChartCheckbox;
